import React from 'react';

const ModalError = params => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={params.width || 100}
    height={params.height || 100}
    viewBox="0 0 100 100"
  >
    <path
      fill={params.color || '#FF5D55'}
      d="M20.537 79.463c-16.272-16.272-16.272-42.654 0-58.926s42.654-16.272 58.926 0 16.272 42.654 0 58.926-42.654 16.272-58.926 0zM50 44.107L38.215 32.322c-1.627-1.627-4.265-1.627-5.893 0-1.627 1.628-1.627 4.266 0 5.893L44.107 50 32.322 61.785c-1.627 1.627-1.627 4.265 0 5.893 1.628 1.627 4.266 1.627 5.893 0L50 55.893l11.785 11.785c1.627 1.627 4.265 1.627 5.893 0 1.627-1.628 1.627-4.266 0-5.893L55.893 50l11.785-11.785c1.627-1.627 1.627-4.265 0-5.893-1.628-1.627-4.266-1.627-5.893 0L50 44.107z"
    />
  </svg>
);

export default ModalError;
